import React, {useState} from 'react';
import {Button, Chip, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow,} from "@mui/material";
import TableHeader from "../layout/table/TableHeader";
import NoDataLabel from "../layout/NoDataLabel";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ModalDelete from "../layout/ModalDelete";
import {useNavigate} from "react-router-dom";
import Constants from "../../../utils/constants";
import './FormsTable.css'
import {helper} from "../../../utils/helper.js";
import BadgeTypeLavage from "../layout/BadgeTypeLavage.js";

function FormsTable({forms, ...props}) {
    const navigate = useNavigate()
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('client');
    const [label, setLabel] = useState("")
    const [objectToDelete, setObjectToDelete] = useState(null)
    const [open, setOpen] = useState(false);
    const [currentForm, setCurrentForm] = useState(null);

    // Table head cells
    const headCells = [
        {id: 'client', label: 'Client'},
        {id: 'libelle', label: 'Libellé'},
        {id: 'type', label: 'Type'},
        {id: 'hasQrcode', label: 'Qrcode'},
        {id: 'hasBarcode', label: 'Barcode'},
        {id: 'hasRFID', label: 'RFID'},
        {id: 'hasVolume', label: 'Volume'},
        {id: 'hasWaste', label: 'Type déchet'},
    ];


    const openDeleteConfirmModal = (f) => {
        setCurrentForm(f)
        setLabel("Etes vous sûr de vouloir supprimer le formulaire : ")
        setObjectToDelete(f.libelle)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentForm(null)
    };

    const handleEditClick = (id) => {
        navigate(Constants.APP_ROUTE_ADMIN_FORMS_EDIT.replace(':id', id))
    }

    const handleDelete = () => {
        props.onDelete(currentForm)
        handleClose()
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const getItemComparator = (item, comparator) => {
        return item[comparator];
    }
    const sortedData = () => {
        return forms.sort((a, b) => {
            if (order === 'asc') {
                return (getItemComparator(a, orderBy) > getItemComparator(b, orderBy)) ? 1 : (getItemComparator(b, orderBy) > getItemComparator(a, orderBy)) ? -1 : 0;
            }
            return (getItemComparator(a, orderBy) < getItemComparator(b, orderBy)) ? 1 : (getItemComparator(b, orderBy) < getItemComparator(a, orderBy)) ? -1 : 0
        });
    }

    const getValueLibelle = (bool) => {
        return bool ? "OUI" : "NON";
    }

    const getValueColor = (bool) => {
        return bool ? "#2e8b57" : "#b22222"
    }


    return (
        <React.Fragment>
            <TableContainer component={Paper} className={"mt-2"}>
                <Table aria-label="forms table" size="small">
                    <TableHeader headCells={headCells} order={order} orderBy={orderBy}
                                 onRequestSort={handleRequestSort}/>
                    <TableBody>
                        {forms && forms.length === 0 &&
                            <TableRow>
                                <TableCell colSpan={10} align={"center"}>
                                    <NoDataLabel label={"Il n'y a encore aucun formulaire enregistré"}/>
                                </TableCell>
                            </TableRow>
                        }
                        {forms && sortedData().map((form) => {
                            return (
                                <React.Fragment key={form.id}>
                                    <TableRow hover onClick={() => handleEditClick(form.id)}
                                              style={{cursor: 'pointer'}}>
                                        <TableCell>
                                            {form.client?.libelle}
                                        </TableCell>
                                        <TableCell>
                                            {form.libelle}
                                        </TableCell>
                                        <TableCell>
                                            <BadgeTypeLavage type={form.type}/>
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                label={getValueLibelle(form.hasQrcode)}
                                                style={{
                                                    backgroundColor: getValueColor(form.hasQrcode),
                                                    color: 'white'
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                label={getValueLibelle(form.hasBarcode)}
                                                style={{
                                                    backgroundColor: getValueColor(form.hasBarcode),
                                                    color: 'white'
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                label={getValueLibelle(form.hasRFID)}
                                                style={{
                                                    backgroundColor: getValueColor(form.hasRFID),
                                                    color: 'white'
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                label={getValueLibelle(form.hasVolume)}
                                                style={{
                                                    backgroundColor: getValueColor(form.hasVolume),
                                                    color: 'white'
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                label={getValueLibelle(form.hasWaste)}
                                                style={{
                                                    backgroundColor: getValueColor(form.hasWaste),
                                                    color: 'white'
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Grid container justify={"flex-end"} spacing={2}>
                                                <Grid item>
                                                    <Button color="secondary" size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleEditClick(form.id)
                                                            }}
                                                            startIcon={<ModeEditOutlineOutlinedIcon/>}>
                                                        Editer
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button color="error" size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openDeleteConfirmModal(form)
                                                            }}
                                                            startIcon={<CloseOutlinedIcon/>}>
                                                        Supprimer
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <ModalDelete label={label} onClose={handleClose} open={open} objectToDelete={objectToDelete}
                         selectedValue={currentForm} onDelete={handleDelete}/>
        </React.Fragment>
    )
}

export default FormsTable;
